export class DrpAnalyticsConstants {
  public static readonly DRP_SEARCH_NO_RESULTS_FOUND = 'drpNoResultsFound';
  public static readonly DRP_SEARCH_LOCATION_RESULTS_FOUND = 'drpLocationResultsFound';
  public static readonly DRP_SEARCH_NAME_RESULTS_FOUND = 'drpNameResultsFound';
  public static readonly DRP_SEARCH_ERROR = 'drpServiceError';
  public static readonly DRP_NO_RESULTS_FOUND = 'drpNoResultsFound';
  public static readonly DRP_RESULTS_FOUND = 'drpResultsFound';
  public static readonly RENTAL_NO_RESULTS_FOUND = 'rentalNoResultsFound';
  public static readonly RENTAL_RESULTS_FOUND = 'rentalResultsFound';
}
